import { EMPTY_VALUE, SETTING_UNITS_KEY } from '@src/core/config';
import { UnitType } from '@src/core/enums';

export const arcTemperature = (value?: number | null) => {

  const payload = Number(value);

  const type = localStorage.getItem(SETTING_UNITS_KEY);

  if (isNaN(payload)) return EMPTY_VALUE;

  if (type === UnitType.SI) return Math.round(payload) + ' °C';

  if (type === UnitType.IMPERIAL) {
    return Math.round((payload * 9/5) + 32) + ' °F';
  }
  
  return EMPTY_VALUE;

};